import {TransactionResponse} from "@/types/service-response";

export default class Transaction {
  private constructor(
      readonly id: number,
      readonly createdAt: string,
      readonly status: string,
      readonly datePosted: string,
      readonly dateAvailable: string,
      readonly amount: number,
      readonly variableSymbol: number,
      readonly specificSymbol: number,
      readonly constantSymbol: number,
      readonly name: string,
      readonly reference: string,
      readonly memo: string,
      readonly fromIban: string,
      readonly currency: string
  ) {}


  static createFromResponse(responseData: TransactionResponse): Transaction {
    return new Transaction(
      responseData.id,
      responseData.createdAt,
      responseData.status,
      responseData.datePosted,
      responseData.dateAvailable,
      responseData.amount,
      responseData.variableSymbol,
      responseData.specificSymbol,
      responseData.constantSymbol,
      responseData.name,
      responseData.reference,
      responseData.memo,
      responseData.fromIban === 'not-provided' ? '-' : responseData.fromIban,
      responseData.currency
    )
  }
}